import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './style/reset.css'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
Vue.config.productionTip = false

import Loading from '@/components/loading/loading.js';
Vue.use(Loading)

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
